// extracted by mini-css-extract-plugin
export default {"content":"style_content__7s1mJ","container":"style_container__D5WMQ"};